// ═══════════════════════════════════════════════════════════
// Jurisdiction Context — provides active jurisdiction to portal pages
// ═══════════════════════════════════════════════════════════

import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { listJurisdictions, type Jurisdiction } from '../api/jurisdiction';

const JurisdictionContext = createContext<Jurisdiction | null>(null);

export function useJurisdiction() {
  return useContext(JurisdictionContext);
}

export function JurisdictionProvider({ children }: { children: ReactNode }) {
  const [jurisdiction, setJurisdiction] = useState<Jurisdiction | null>(null);

  useEffect(() => {
    // Load anonymously — portal has no staff auth
    listJurisdictions({ anonymous: true }).then(list => {
      if (list.length > 0) setJurisdiction(list[0]);
    }).catch(() => {});
  }, []);

  return (
    <JurisdictionContext.Provider value={jurisdiction}>
      {children}
    </JurisdictionContext.Provider>
  );
}
